module.exports = __webpack_public_path__ + "img/arrow-up-big-small.85aeb938.svg";